<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" titulo="Ofertas" style="flex: 1 0 100%" />
    <div slot="contenido">
      <div class="tarjetario">
        <PromocionSaludSeVital v-if="visiblePromocionSaludSeVital" class="tarjeta" />
        <PromocionRegaloAspirador v-if="visiblePromocionRegaloAspirador" class="tarjeta"/>
        <PromocionSalud1MesGratis v-if="visiblePromocionSeguroSalud1MesGratis" class="tarjeta" />
        <PromocionSalud1MesGratis v-if="visiblePromocionSeguroSalud1MesGratis" class="tarjeta" />
        <PromocionMesMMTFebrero2026 v-if="visiblePromocionMesMMTFebrero2026" class="tarjeta"/>
        <PromocionBlackFriday2025 v-if="visiblePromocionBlackFriday2025" class="tarjeta" />
        <TraeUnAmigo v-if="visibleTraeUnAmigo" class="tarjeta" />
        <SeguroHogar v-if="visibleSeguroHogar" class="tarjeta" />
        <SeguroMascotas v-if="visibleSeguroMascotas" class="tarjeta" />
        <SeguroAccidentes v-if="visibleSeguroAccidentes" class="tarjeta" />
        <SeguroNegocios v-if="visibleSeguroNegocios" class="tarjeta" />
        <SeguroMovilidadPersonal v-if="visibleSeguroMovilidadPersonal" class="tarjeta" />
        <SeguroMovilidadVMP v-if="visibleSeguroMovilidadVMP" class="tarjeta" />
        <AhorraConTuTaxi v-if="visibleAhorraConTuTaxi" class="tarjeta" />
        <Hogar90 v-if="visiblePromocionHogar90" class="tarjeta" />
        <SeguroAuto v-if="visibleSeguroAuto" class="tarjeta" /> 
        <SeguroMoto v-if="visibleSeguroMoto" class="tarjeta" />
        
      </div>
    </div>
  </TemplateConMenuLateral>
</template>

<script>


export default {
  computed: {
    visiblePromocionSaludSeVital() {
      return new Date() < new Date('2027-01-11T00:00:00') &&
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaSaludHNA == "N" &&
        this.$store.state.portfolio.tienePolizaSaludMMT == "N";
    },

    visibleTraeUnAmigo() {
      return this.$store.state.portfolio.nsg("lstCodigosAmigo.length") > 0;
    },
    visiblePromocionHogar90() {
      return this.$store.state.portfolio.visiblePromocionHogar90;
    },
    visibleSeguroAuto() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaAuto == "N"
      );
    },
    visibleSeguroHogar() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaHogar == "N" 
      );
    },

    visibleSeguroMoto() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMoto == "N"
      );
    },

    
    visibleSeguroAccidentes() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaAccidentes == "N"

      );
    },

    visibleSeguroMascotas() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMascotas == "N"
      );
    },

    visibleSeguroMovilidadPersonal() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMovilidadPersonal == "N"

      );
    },

    visibleSeguroMovilidadVMP() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMovilidadVMP == "N"

      );
    },

    visibleSeguroNegocios() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaNegocio == "N"

      );
    },


    visibleAhorraConTuTaxi() {
      return (
        // para optimizar tiempos pasamos logica al java
        this.$store.state.portfolio.visibleAhorraConTuTaxi
      );
    },  

     visiblePromocionSeguroSalud1MesGratis(){
       const ahora = new Date();
       const fechaFin = new Date('2026-06-30T23:59:59');
       const isMostrarHoy =   ahora <= fechaFin;
       const mostrarSeguroSalud = isMostrarHoy && this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaSaludHNA == "N" &&
        this.$store.state.portfolio.tienePolizaSaludMMT == "N" &&
        this.$store.state.portfolio.cliente.edad != null && 
        this.$store.state.portfolio.cliente.edad < 65;
  
      return mostrarSeguroSalud;
    },

    visiblePromocionBlackFriday2025(){
      const ahora = new Date();
      const fechaInicio = new Date('2025-11-17T00:00:00');
      const fechaFin = new Date('2025-11-29T23:59:59');
      const isPromocionVigor =  ahora >= fechaInicio && ahora <= fechaFin;
      
      return isPromocionVigor && this.$store.state.portfolio.cliente.purezaPuroMMT ;
    },

     visiblePromocionMesMMTFebrero2026(){
      const ahora = new Date();
      const fechaFin = new Date('2026-02-28T23:59:59');
      const isPromocionVigor =  ahora <= fechaFin;
      return isPromocionVigor && this.$store.state.portfolio.cliente.purezaPuroMMT ;
    },
    
    visiblePromocionRegaloAspirador(){
     return this.$store.state.portfolio.visiblePromocionRegaloAspirador;
    }, 

  },
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";
</style>
